import { SearchSectionItems } from '@app/entities/models/search/search-section-items.model';

export class SearchSection {
  showViewAll!: boolean;
  items!: SearchSectionItems[];
}
